// src/services/salesTemplates.service.js
import { request } from "./http";

export const salesTemplatesService = {
  list({ channelType } = {}) {
    const params = new URLSearchParams();
    if (channelType) params.set("channelType", channelType);

    const qs = params.toString();
    return request(`/SalesTemplates${qs ? `?${qs}` : ""}`);
  },

  getById(id) {
    return request(`/SalesTemplates/${id}`);
  },

  create(payload) {
    return request("/SalesTemplates", { method: "POST", body: payload });
  },

  update(id, payload) {
    return request(`/SalesTemplates/${id}`, { method: "PUT", body: payload });
  },

  remove(id) {
    return request(`/SalesTemplates/${id}`, { method: "DELETE" });
  },
};
